import { Box, TextField, Typography } from '@mui/material';
import type { ChangeEventHandler } from 'react';
import { Controller } from 'react-hook-form';
import type { FormTextFieldProps } from './types';

export default function FormTextField({
	control,
	name,
	muiProps,
	label,
	boxProps,
	isRequired,
}: FormTextFieldProps) {
	return (
		<Box display="flex" flexDirection="column" {...boxProps}>
			{label && (
				<Typography
					variant="body2"
					fontWeight={600}
					sx={{ marginBottom: '6px' }}
				>
					{label}
					{isRequired && ' *'}
				</Typography>
			)}
			<Controller
				control={control}
				name={name}
				render={({ field, fieldState: { error } }) => {
					const handleChange: ChangeEventHandler<
						HTMLInputElement | HTMLTextAreaElement
					> = (event) => field.onChange(event.target.value);

					return (
						<TextField
							{...field}
							{...muiProps}
							value={field.value ?? ''}
							variant="outlined"
							size="small"
							onChange={handleChange}
							error={!!error}
							helperText={muiProps?.helperText}
							autoComplete="off"
							fullWidth
						/>
					);
				}}
			/>
		</Box>
	);
}
